import React, { useEffect, useState } from "react"
import { NextIntlClientProvider } from "next-intl"
import { useLocaleStore } from "@/stores/localeStore"
import { messages } from "../../messages"

export const IntlProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const { locale } = useLocaleStore()
	const [currentMessages, setCurrentMessages] = useState(messages[locale])

	useEffect(() => {
		setCurrentMessages(messages[locale])
	}, [locale])

	return (
		<NextIntlClientProvider locale={locale} messages={currentMessages} timeZone="Europe/Madrid">
			{children}
		</NextIntlClientProvider>
	)
}
